<template>
  <div class="box">
    <!-- <img src="./按钮.png" alt=""> -->
    <div class="leftTag">
      <el-button type="primary" @click="addTagClk">创建标签</el-button>
      <div class="leftTagList">
        <div v-for="(item, index) in leftTagList" :key="index" class="leftTagItem" @click="leftTagItemClk(item, index)" :class="{ leftTagItemActive: leftTagId == index }">
          {{ item.tagName }}
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 左侧用户列表区域 -->
      <div class="Recentchats">
        <!-- 搜索、全部，已读未读 - 固定在顶部 -->
        <div class="FunctionalArea">
          <el-input placeholder="请输入手机号" clearable @clear="clear" @keyup.enter.native="handleSearchEnter" prefix-icon="el-icon-search" v-model="queryData.userName"> </el-input>
          <el-tabs v-model="activeName" @tab-click="tabHandleClick">
            <el-tab-pane label="全部" name="2"></el-tab-pane>
            <el-tab-pane label="未读" name="0"></el-tab-pane>
            <el-tab-pane label="已读" name="1"></el-tab-pane>
          </el-tabs>
        </div>

        <!-- 用户列表区域 - 可滚动 -->
        <!-- <div class="UserListArea"> -->
        <ul v-if="show" class="UserListArea infinite-list" v-infinite-scroll="load" infinite-scroll-distance="50" :infinite-scroll-disabled="loading || !hasMore">
          <!-- <ul class="infinite-list" v-infinite-scroll="load" infinite-scroll-distance="50" infinite-scroll-immediate="false" :infinite-scroll-disabled="!socket.send"> -->
          <!-- <li v-for="i in count" :key="i" class="infinite-list-item">测试数据 {{ i }}</li> -->

          <!-- 用户列表内容 -->
          <div
            v-for="(item, index) in filteredUserList"
            :key="item.id"
            class="RecentchatsItem"
            :class="{
              RecentchatsItemActive: item.toUserName == userId,
              'has-unread': item.unreadCount && item.unreadCount > 0
            }"
            @click="userClk(item, index)"
          >
            <!-- {{ item.id }} -->
            <div class="itemRight">
              <el-badge :value="item.unreadCount" :hidden="!item.unreadCount || item.unreadCount === 0" :max="99" class="user-badge">
                <div class="userInfo">
                  <div class="name">{{ item.toUserName }}</div>
                  <div class="userTag">
                    <div class="userTagItem" v-for="(tag, index1) in item.toTag?.split(',').filter((t) => t.trim())" :key="index1">{{ tag.trim() }}</div>
                  </div>
                </div>
              </el-badge>
            </div>

            <el-dropdown @command="handleCommand" trigger="click" v-if="item.toUserName == userId">
              <div class="more" @click.stop="moreClk(item, index)">
                <i class="el-icon-more"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">标签</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- 加载状态提示 -->
          <li v-if="loading" class="loading-item"><i class="el-icon-loading"></i> 加载中...</li>
          <li v-if="!hasMore" class="no-more-item">没有更多数据了</li>
        </ul>
        <!-- </div> -->
      </div>
      <!-- 右侧聊天区域 -->
      <div class="Chatarea">
        <!-- 右侧上部名称展示 -->
        <div class="ChatareaName">{{ toUserName }}</div>
        <!-- 右侧聊天区域 -->
        <div class="ChatareaText" :class="{ 'drag-over': isDragOver }" @dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave" @scroll="onChatScroll">
          <!-- 顶部loading -->
          <div v-if="chatLoading" class="chat-loading">
            <i class="el-icon-loading"></i>
            <span>加载中...</span>
          </div>
          <div v-for="(item, index) in list" :key="index" class="listContent">
            <div class="time" style="text-align: center">
              {{ getTime(item.createTime) }}
            </div>
            <div v-if="item.to == imToken" class="left_view">
              <img src="@/assets/02.png" alt="" />
              <div class="leftText">
                <div v-if="item.msgType === 2" class="image-message">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item.content"
                    :preview-src-list="[item.content]"
                    @click="previewImage(item.content)"
                    fit="contain">
                  </el-image>
                </div>
                <div v-else class="text-message">{{ item.content }}</div>
              </div>
            </div>
            <div v-else class="right_view">
              <div class="rightText">
                <div v-if="item.msgType === 2" class="image-message">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item.content"
                    :preview-src-list="[item.content]"
                    @click="previewImage(item.content)"
                    fit="contain">
                  </el-image>
                </div>
                <div v-else class="text-message">{{ item.content }}</div>
              </div>
              <img src="@/assets/01.png" alt="" />
            </div>
          </div>
        </div>

        <!-- 右侧底部聊天发送信息 -->
        <div class="ChatareaSend">
          <div class="sendText">
            <el-input v-model="textarea" type="textarea" :rows="2" placeholder="按Enter发送,Enter+Shift换行" @keydown.native="onInputKeydown" />
          </div>
          <div class="sendActions">
            <input ref="imageInput" type="file" accept="image/*" style="display: none" @change="handleImageSelect" />
            <el-button type="primary" @click="selectImage" title="发送图片"> 图片 </el-button>
            <el-button type="primary" class="sendBtn" @click="sendClk">发送</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <!-- <el-dialog :visible.sync="imagePreviewVisible" :show-close="true" width="80%" center> -->
    <!-- <img :src="previewImageUrl" alt="图片预览" style="width: 100%; max-height: 70vh; object-fit: contain" /> -->
    <!-- <el-image style="width: 100px; height: 100px" :src="previewImageUrl" :preview-src-list="srcList"> </el-image> -->
    <!-- </el-dialog> -->
    <!-- 创建新的标签弹窗 tagDialogVisible -->
    <el-dialog title="新建标签" :visible.sync="tagDialogVisible" width="30%">
      <el-form ref="tagForm" :model="addTagForm" label-width="80px">
        <el-form-item label="新建标签">
          <el-input v-model="addTagForm.tagName"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="tagDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="tagDialogVisibleClk">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 点击用户后面更多,选择标签 -->
    <el-dialog title="选择标签" :visible.sync="xuanTagDialogVisible" width="30%">
      <!-- 标签 -->
      <div class="tagList">
        <div class="tag-buttons">
          <el-button class="tag-add-btn" type="text" icon="el-icon-plus" @click="tagDialogVisible = true"> + 新增标签值 </el-button>

          <div class="tag-row">
            <el-button v-for="tag in leftTagList.slice(1)" :key="tag.tagName" :class="['tag-btn', { 'tag-selected': selectedTags.includes(tag.tagName) }]" @click="toggleTagClk(tag.tagName)">
              {{ tag.tagName }}
              <i v-if="selectedTags.includes(tag.tagName)" class="el-icon-check tag-check"></i>
            </el-button>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="xuanTagDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="xuanTagDialogVisibleClk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// let socket;
import moment from "moment";
import axios from "axios";
export default {
  data () {
    return {
      // 左侧功能区

      show: false, // 是否加载
      loading: false, // 加载状态
      hasMore: true, // 是否还有更多数据
      queryData: {
        pageNum: 0,
        pageSize: 10,
        userName: "",
        queryTag: '',//0->未读,1->已读
        userTag: "",
        userId: ""
      },
      activeName: '2',
      // 左侧标签部分
      addTagForm: {
        fromApp: "OH5X0OW5",
        tagName: "",
        userId: ""
      },
      leftTagId: '',
      leftTagList: [
        {
          tagName: "全部"
        }
      ],
      userClickId: '',
      userTagName: "",
      tagDialogVisible: false,
      xuanTagDialogVisible: false,
      // 标签相关数据（多选：存放选中的 tagName 字符串）
      selectedTags: [],
      // 当前选中的用户数据
      currentUserItem: null,
      // 加载超时ID
      loadTimeoutId: null,
      // 左侧功能区EEEE
      socket: null,
      userListIndex: 0,
      textarea: "",
      isDragOver: false,
      userList: [],
      userId: "",
      toUserName: "",
      itemTo: "",
      list: [],
      imToken: "",
      getUserState: false,
      listContent: [],
      isWebSocketConnected: false,
      makeInterval: null,
      reconnectTimer: null,
      reconnectDelay: 5000,
      reconnectPending: false,
      shouldReconnect: true,
      appId: "OH5X0OW5", //产品名称
      // 消息提醒相关
      titleBlinkTimer: null,
      originalTitle: "在线客服",
      notificationPermission: false,
      audioContext: null,
      currentNotification: null,
      unreadCount: 0,//新消息提示
      notificationDebounceTimer: null, // 通知防抖定时器
      lastNotificationTime: 0, // 上次通知时间
      notificationQueue: [], // 通知队列
      isProcessingNotification: false, // 是否正在处理通知
      // 图片相关
      srcList: [],
      imagePreviewVisible: false,
      previewImageUrl: '',
      selectedImage: null,
      // 搜索防抖定时器
      searchTimer: null,
      // 聊天记录分页相关
      chatPageNum: 1,
      chatPageSize: 20,
      chatHasMore: true,
      chatLoading: false,
      chatTotal: 0,
      scrollTimer: null, // 滚动防抖定时器
      // 历史消息加载标记：是否首次加载（决定替换或前置）
      chatHistoryFirstLoadPending: false,
      // 最后处理的消息ID，用于避免重复累加未读数
      lastProcessedMessageId: null,
    };
  },
  created () {
    this.imToken = sessionStorage.getItem("imToken");
    this.originalTitle = document.title;

    console.log(this.imToken, 'this.imToken');
    // 监听浏览器 当前系统是否在当前页
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    // 请求通知权限
    this.requestNotificationPermission();

  },
  mounted () {
    this.initWebSocket();
    this.getTagList()
  },

  beforeUnmount () {
    // 断开WebSocket连接
    if (this.socket) {
      this.socket.close();
    }
    this.isWebSocketConnected = false;
    this.shouldReconnect = false;

    // 清理所有定时器
    this.clearAllTimers();

    // 恢复原始标题
    document.title = this.originalTitle;

    // 清理通知
    if (this.currentNotification) {
      this.currentNotification.close();
      this.currentNotification = null;
    }

    // 清理事件监听器
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
  computed: {
    // 如果使用后端接口，这里可以简化为直接返回 userList
    // 或者根据后端返回的数据结构进行调整
    filteredUserList () {
      // 过滤掉无效项，避免模板访问 undefined 属性
      const list = (this.userList || []).filter(u => u && typeof u === 'object');
      if (this.activeName === '0') {
        // 未读
        return list.filter(u => (u.unreadCount || 0) > 0);
      }
      if (this.activeName === '1') {
        // 已读
        return list.filter(u => (u.unreadCount || 0) === 0);
      }
      // 全部
      return list;
    }
  },
  methods: {
    // 清理所有定时器
    clearAllTimers () {
      if (this.makeInterval) {
        clearInterval(this.makeInterval);
        this.makeInterval = null;
      }
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = null;
      }
      if (this.titleBlinkTimer) {
        clearInterval(this.titleBlinkTimer);
        this.titleBlinkTimer = null;
      }
      if (this.notificationDebounceTimer) {
        clearTimeout(this.notificationDebounceTimer);
        this.notificationDebounceTimer = null;
      }
      this.clearReconnect();
    },
    resetUnreadCount () {
      this.unreadCount = 0;
    },

    getTime (time) {
      // 确保 time 是有效的时间戳或日期字符串
      if (!time) return '';
      const momentTime = moment(time);
      if (!momentTime.isValid()) {
        console.warn('Invalid time format:', time);
        return '';
      }
      return momentTime.format("YYYY-MM-DD HH:mm:ss");
    },
    fiveMinutes (date1, date2, i) {
      return moment(date1).format("YYYY-MM-DD HH:mm:ss");
    },
    toBottom () {
      this.$nextTick(() => {
        const box = document.getElementsByClassName("ChatareaText")[0];
        box.scrollTop = box.scrollHeight;
      });
    },
    // 左侧标签,添加标签,分配标签部分 EEEEEE
    // 获取标签分页
    getTagList () {
      let data = {
        pageNum: 1,
        pageSize: 10,
        model: {
          userId: sessionStorage.getItem('userID')

        }
      }
      // axios.post("https://openim-api.maerskwork.com/hub/tag/page", data).then((res) => {
        axios.post("http://192.168.110.122:9004/hub/tag/page", data).then((res) => {
        const fetched = Array.isArray(res.data?.data?.data) ? res.data.data.data : []
        // 融合“全部”与接口返回，并去重
        this.leftTagList = this.mergeUniqueTags(this.leftTagList, fetched)
        // console.log(this.leftTagList, 'this.leftTagList');
      })
    },
    // 融合两个数组并按标签唯一键去重
    mergeUniqueTags (listA, listB) {
      // 将新数据放在前面，原有数据放在后面
      const merged = [...(Array.isArray(listB) ? listB : []), ...(Array.isArray(listA) ? listA : [])]
      const seen = new Set()
      const result = []

      // 先处理"全部"标签，确保它在第一位
      const allTag = merged.find(item => item.tagName === "全部")
      if (allTag) {
        result.push(allTag)
        seen.add(allTag.tagName)
      }

      // 然后处理其他标签
      merged.forEach(item => {
        const key = item.id || item.tagId || item.tagName
        if (!seen.has(key)) {
          seen.add(key)
          result.push(item)
        }
      })
      return result
    },
    // 左侧功能区标签页切换
    addTagClk () {
      this.tagDialogVisible = true;
      this.addTagForm.tagName = '';

    },
    // 新建标签
    tagDialogVisibleClk () {
      this.addTagForm.userId = sessionStorage.getItem('userID')
      // axios.post("https://openim-api.maerskwork.com/hub/tag/add", this.addTagForm).then((res) => {
        axios.post("http://192.168.110.122:9004/hub/tag/add", this.addTagForm).then((res) => {
        this.tagDialogVisible = false
        if (res.data.code == 20000) {
          this.$message.success(res.data.message)
          // 将新标签添加到"全部"之后的位置（索引1）
          if (res.data.data) {
            this.leftTagList.splice(1, 0, res.data.data)
          }
          // 或者重新获取标签列表
          // this.getTagList()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    //  用户添加标签（打印所有选中的 tagName）
    xuanTagDialogVisibleClk () {
      let chatSessionId = this.userClickId;
      // 多选列表 -> 逗号分隔的字符串
      const sessionTag = (this.selectedTags || []).join(',');
      // console.log('选中的标签:', sessionTag);
      // console.log('chatSessionId:', chatSessionId);
      this.xuanTagDialogVisible = false;
      // axios.post("https://openim-api.maerskwork.com/hub/im/setChatSessionTag", { chatSessionId, sessionTag }).then((res) => {
        axios.post("http://192.168.110.122:9004/hub/im/setChatSessionTag", { chatSessionId, sessionTag }).then((res) => {
        // console.log(res.data);
        if (res.data.code == 20000) {
          this.$message.success(res.data.message)
          this.queryData.pageNum = 0
          this.load()
        } else {
          this.$message.error(res.data.message)

        }

      })
    },
    // 清空搜索框
    clear () {
      this.queryData.userName = '';
      this.handleSearchEnter()
    },
    handleSearchEnter () {
      this.hasMore = true;
      this.queryData.pageNum = 0
      this.userList = []
      this.show = false;
      this.$nextTick(() => {
        setTimeout(() => {
          // console.log(this.loading, 'loading');

          this.show = true;
        }, 0)
      })
    },
    // 标签相关方法：多选切换（以 tagName 字符串为键）
    toggleTagClk (tagName) {
      this.userTagName = tagName
      const index = this.selectedTags.indexOf(tagName);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tagName);
      }
    },
    // 根据标签页和搜索条件获取用户列表
    getUserListByTab () {
      this.userList = []
      this.show = true;
      this.queryData.pageNum = 0
      // 重置加载状态
      this.loading = false
      this.hasMore = true
      this.load()
    },

    tabHandleClick (tab, event) {
      // console.log('切换到标签页:', tab.name);
      // 切换标签时清空右侧聊天区并重置聊天加载状态
      this.list = [];
      this.itemTo = '';
      this.toUserName = '';
      this.userId = '';
      this.chatPageNum = 1;
      this.chatHasMore = true;
      this.chatLoading = false; // 关键：切页时停止聊天区 loading
      this.chatHistoryFirstLoadPending = false; // 取消任何未决的首开状态
      this.show = true;
      if (tab.name == '2') {
        this.queryData.queryTag = ''
        this.userList = []
        this.getUserListByTab();

      } else if (tab.name == '1') {
        this.queryData.queryTag = '1'
        this.userList = []
        this.getUserListByTab();
      } else if (tab.name == '0') {
        this.queryData.queryTag = '0'
        this.userList = []
        this.getUserListByTab();
      }
    },
    // 标签页部分操作
    leftTagItemClk (item, index) {
      this.leftTagId = index;
      this.queryData.userId = sessionStorage.getItem('userID')
      if (item.tagName == '全部') {
        this.queryData.userTag = ''
      } else {
        this.queryData.userTag = item.tagName
      }
      this.show = true;
      this.userList = []
      this.queryData.pageNum = 0
      // 重置加载状态
      this.loading = false
      this.hasMore = true
      this.load()
    },
    // 左侧用户渲染,已读,未读部分  EEEEEE
    // 渲染左侧会话列表
    load () {
      // console.log(this.loading || !this.hasMore, this.loading, !this.hasMore, 'this.loading || !this.hasMore');

      // 防止重复加载
      if (this.loading || !this.hasMore) {
        return;
      }
      this.queryData.pageNum++;
      this.loading = true;

      // 设置超时处理，防止 WebSocket 响应异常导致 loading 状态一直为 true
      // const timeoutId = setTimeout(() => {
      //   if (this.loading) {
      //     // console.log('WebSocket 响应超时，重置 loading 状态');
      //     this.loading = false;
      //   }
      // }, 10000); // 10秒超时

      this.socket.send(
        JSON.stringify({
          cmd: 3,
          seq: 1,
          pageNum: this.queryData.pageNum,
          pageSize: this.queryData.pageSize,
          userName: this.queryData.userName,
          appId: this.appId,
          token: this.imToken,
          queryTag: this.queryData.queryTag,
          userTag: this.queryData.userTag,
          userId: this.queryData.userId,
        })
      );

      // 保存超时ID，在收到响应时清除
      // this.loadTimeoutId = timeoutId;
    },
    asd (data) {
      const that = this;
      let i = 0;
      let val = "";
      let shouldNotify = false;

      // 先判断是否是当前聊天用户
      const isCurrentChatUser = (
        (data.from === that.itemTo && data.to === that.imToken) ||
        (data.from === that.imToken && data.to === that.itemTo)
      );

      that.userList.forEach((v, k) => {
        if (v.to == data.from) {
          // 完全移除未读数累加，只在 cmd==11 中处理
          // v.unreadCount = v.unreadCount || 0;
          // v.unreadCount++;
          i = k;
          val = v;
          // 只有在不是当前聊天用户时才需要通知
          shouldNotify = !isCurrentChatUser;
        }
      });


      if (shouldNotify && val.toUserName) {
        this.showNewMessageAlert(`${val.toUserName} 发来新消息`);
      }

      // 将命中会话置顶：需要确保索引有效，避免引入 undefined
      if (shouldNotify && i >= 0 && i < that.userList.length) {
        const current_user = that.userList[i];
        if (current_user) {
          that.userList.splice(i, 1);
          that.userList.unshift(current_user);
          that.$set(that.userList, i, that.userList[i]);
        }
      }

      // 仅当消息属于当前打开的会话时，才展示在聊天框
      const isCurrentChat = (
        (data.from === that.itemTo && data.to === that.imToken) ||
        (data.from === that.imToken && data.to === that.itemTo)
      );

      if (isCurrentChat) {
        that.list.push(data);
        that.toBottom();
        // 无条件标记为已读并清零当前会话未读
        this.allMessageRead();
        // 清零当前会话未读计数（双保险）
        const current = this.userList.find(u => u.to === this.itemTo || u.id === this.itemTo || u.toUserName === this.userId);
        if (current) {
          current.unreadCount = 0;
        }
        if (val) {
          val.unreadCount = 0;
        }
        this.$forceUpdate();
      }
    },
    // 点击用户后面的更多
    moreClk (item, index) {
      // console.log(item, index);
      // console.log('点击更多');
      this.userClickId = item.id
      // 保存当前用户数据，用于后续标签选择
      this.currentUserItem = item
    },
    handleCommand (command) {
      // 打开标签选择对话框时，根据当前用户的标签预选
      this.initSelectedTags()
      this.xuanTagDialogVisible = true
    },
    // 初始化选中标签（根据当前用户的toTag）
    initSelectedTags () {
      // 清空之前的选择
      this.selectedTags = []

      // 如果有当前用户数据且用户有标签
      if (this.currentUserItem && this.currentUserItem.toTag) {
        // 将用户的标签字符串转换为数组
        const userTags = this.currentUserItem.toTag.split(',').filter(tag => tag.trim())

        // 检查这些标签是否在可用的标签列表中
        const availableTagNames = this.leftTagList.slice(1).map(tag => tag.tagName)

        // 只添加在可用标签列表中的标签
        userTags.forEach(tag => {
          const trimmedTag = tag.trim()
          if (availableTagNames.includes(trimmedTag)) {
            this.selectedTags.push(trimmedTag)
          }
        })

        // console.log('初始化选中标签:', this.selectedTags)
      }
    },
    // 点击用户
    userClk (item, index) {
      // console.log(item, "00000");
      // 清除未读消息计数
      item.unreadCount = 0;
      // 同时更新 userList 中对应的项
      const userInList = this.userList.find(u => u && (u.id === item.id || u.to === item.to));
      if (userInList) {
        userInList.unreadCount = 0;
      }

      this.itemTo = item.to;
      this.toUserName = item.toUserName;
      this.userId = item.toUserName;
      this.userListIndex = index;
      const from = this.imToken;
      const to = item.to;
      let appId = this.appId;
      // 重置分页数据
      this.chatPageNum = 1;
      this.chatHasMore = true;
      this.list = [];

      // 加载第一页历史消息
      this.loadChatHistory(from, to, appId, true);
      this.allMessageRead()
    },
    // 所有消息已读,
    allMessageRead () {
      this.socket.send(
        JSON.stringify({
          cmd: 10,
          appId: this.appId,
          token: this.imToken,
          toUser: this.itemTo
        })
      );
    },
    // 用户右侧聊天渲染，发送，文字，图片处理部分  EEEEEE
    // 聊天记录分页相关方法
    loadChatHistory (from, to, appId, isFirstLoad = false) {
      // 防重复与无更多保护（避免残留 loading 导致切页后一直显示）
      if (this.chatLoading || !this.chatHasMore) {
        return;
      }
      if (to != '') {
        this.chatLoading = true;
        // 记录此次请求是否首次加载，用于 cmd==12 回包处理
        this.chatHistoryFirstLoadPending = !!isFirstLoad;
        this.socket.send(
          JSON.stringify({
            cmd: 12,
            from,
            to,
            appId,
            pageNum: this.chatPageNum,
            pageSize: this.chatPageSize
          })
        );
      }
      // const params = {
      //   from,
      //   to,
      //   appId,
      //   pageNum: this.chatPageNum,
      //   pageSize: this.chatPageSize
      // };


      // axios.post("http://192.168.110.122:9004/hub/msg/history/page", params).then((res) => {
      //   const newMessages = res.data.data.content || [];
      //   const total = res.data.data.totalElements || res.data.data.total || newMessages.length;

      //   if (isFirstLoad) {
      //     // 首次加载，直接替换
      //     this.list = newMessages.reverse();
      //     this.toBottom();
      //   } else {
      //     // 加载更多，添加到顶部
      //     const currentScrollTop = this.$el.querySelector('.ChatareaText').scrollTop;
      //     const currentScrollHeight = this.$el.querySelector('.ChatareaText').scrollHeight;

      //     this.list = [...newMessages.reverse(), ...this.list];

      //     // 保持滚动位置
      //     this.$nextTick(() => {
      //       const newScrollHeight = this.$el.querySelector('.ChatareaText').scrollHeight;
      //       this.$el.querySelector('.ChatareaText').scrollTop = newScrollHeight - currentScrollHeight + currentScrollTop;
      //     });
      //   }

      //   this.chatTotal = total;
      //   // 如果返回的数据少于pageSize，说明没有更多数据了
      //   this.chatHasMore = newMessages.length >= this.chatPageSize;
      //   this.chatPageNum++;
      // }).catch((error) => {
      //   // console.error("获取消息历史失败:", error);
      // }).finally(() => {
      //   this.chatLoading = false;
      // });
    },
    // 聊天区域滚动事件
    onChatScroll (event) {
      // 清除之前的定时器
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }

      // 防抖处理
      this.scrollTimer = setTimeout(() => {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        // 当滚动到顶部时加载更多
        if (scrollTop <= 20 && this.chatHasMore && !this.chatLoading) {
          const from = this.imToken;
          const to = this.itemTo;
          const appId = this.appId;
          this.loadChatHistory(from, to, appId, false);
        }
      }, 100);
    },

    sendClk () {
      // 非空校验：去除首尾空白后不能为空
      if (!this.textarea || !this.textarea.trim()) {
        this.$message.warning('消息不能为空');
        return;
      }
      // 判断连接状态
      if (!this.isWebSocketConnected) {
        // 如果未连接，进行重连
        this.initWebSocket();
        // 设置一个定时器，每隔一段时间检查连接状态，直到连接成功
        const checkConnectionInterval = setInterval(() => {
          if (this.isWebSocketConnected) {
            // 连接成功后发送消息
            this.socket.send(
              JSON.stringify({
                cmd: 5,
                seq: 1,
                to: this.itemTo,
                appId: this.appId,
                chatType: 1,
                msgType: 1,
                content: this.textarea,
              })
            );
            // 清除定时器
            clearInterval(checkConnectionInterval);
            this.list.push({
              isMine: true,
              content: this.textarea,
              createTime: new Date().toISOString(),
            });
            this.textarea = "";
            this.toBottom();
          }
        }, 1000);
      } else {
        // 如果已连接，直接发送消息
        this.socket.send(
          JSON.stringify({
            appId: this.appId,
            cmd: 5,
            seq: 1,
            to: this.itemTo,
            chatType: 1,
            msgType: 1,
            content: this.textarea,
          })
        );
        //  console.log(this.textarea,'this.textarea');

        this.list.push({
          isMine: true,
          content: this.textarea,
          createTime: new Date().toISOString(),
        });
        //  console.log(this.list,'this.textarea');

        this.textarea = "";
        this.toBottom();
      }
    },
    // Enter 发送，Shift+Enter 换行
    onInputKeydown (e) {
      // Enter 发送，Shift+Enter 换行
      if (e.key === 'Enter') {
        if (e.shiftKey) {
          return; // 允许换行
        }
        e.preventDefault();
        this.sendClk();
      }
    },
    // 文件上传方法
    uploadFile (file) {
      const formData = new FormData()
      formData.append('multipartFile', file)

      return axios({
        // url: 'http://192.168.110.122:9004/hub/file/upload',
        url: 'https://openim-api.maerskwork.com/hub/file/upload',
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    },
    // 图片相关方法
    selectImage () {
      this.$refs.imageInput.click();
    },
    handleImageSelect (event) {
      const file = event.target.files[0];
      if (file) {
        // 检查文件大小（限制为5MB）
        if (file.size > 10 * 1024 * 1024) {
          this.$message.error('图片大小不能超过5MB');
          return;
        }

        // 检查文件类型
        if (!file.type.startsWith('image/')) {
          this.$message.error('请选择图片文件');
          return;
        }

        this.selectedImage = file;
        this.uploadAndSendImage(file);
      }
    },
    uploadAndSendImage (file) {
      // 显示上传进度
      const loading = this.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        // background: 'rgba(0, 0, 0, 0.7)'
      });

      // 直接调用上传API
      this.uploadFile(file)
        .then(response => {
          // 假设服务器返回的数据结构为 { code: 20000, data: { url: 'xxx' } }
          const imageUrl = response.data.data
          if (imageUrl) {
            // 发送图片消息
            this.sendImageMessage(imageUrl);
            loading.close();
            this.$message.success('图片发送成功');
          } else {
            throw new Error('服务器未返回图片链接');
          }
        })
        .catch(error => {
          loading.close();
          console.error('图片上传失败:', error);
          this.$message.error('图片上传失败，请重试');
        });
    },
    sendImageMessage (imageUrl) {
      if (!this.isWebSocketConnected) {
        this.$message.error('连接已断开，无法发送图片');
        return;
      }

      // 发送图片消息到WebSocket
      this.socket.send(
        JSON.stringify({
          cmd: 5,
          seq: 1,
          to: this.itemTo,
          appId: this.appId,
          chatType: 1,
          msgType: 2, // 2表示图片消息
          content: imageUrl,
        })
      );

      // 添加到本地消息列表
      this.list.push({
        isMine: true,
        content: imageUrl,
        msgType: 2,
        createTime: new Date().toISOString(),
      });

      this.toBottom();
    },
    previewImage (imageUrl) {
      // 清空srcList，每次只放大一张图片
      this.srcList = [imageUrl];
      this.previewImageUrl = imageUrl;
      this.imagePreviewVisible = true;
    },
    onDragOver () {
      this.isDragOver = true;
    },
    onDragLeave () {
      this.isDragOver = false;
    },
    // 图片上传
    onDropFiles (e) {
      this.isDragOver = false;
      const dt = e.dataTransfer;
      if (!dt || !dt.files || !dt.files.length) return;
      const file = dt.files[0];
      if (!file) return;
      // 仅允许图片
      if (!file.type || !file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件');
        return;
      }
      // 大小限制 5MB
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('图片大小不能超过5MB');
        return;
      }
      this.selectedImage = file;
      this.uploadAndSendImage(file);
    },
    // ws链接，重连，接收消息部分   EEEEEE
    //     chatType
    //   1 单聊
    //   2 群聊

    // cmd
    //   1 认证请求
    //   2 认证响应
    //   3 在线用户请求
    //   4 在线用户响应
    //   5 聊天请求
    //   6 聊天响应
    //   7 聊天内容
    //   8 心跳检测
    //   9 心跳检测响应
    // 11 新用户第一次发消息：将该会话插入到用户列表首位
    // 12  聊天历史记录
    initWebSocket () {
      if (!this.shouldReconnect) return;
      if (this.socket) {
        try { this.socket.onopen = null; this.socket.onmessage = null; this.socket.onclose = null; this.socket.onerror = null; } catch (e) { }
        try { this.socket.close(); } catch (e) { }
        this.socket = null;
      }
      this.socket = new WebSocket("ws://192.168.110.122:9005/ws/");
      // this.socket = new WebSocket("wss://openim-api.maerskwork.com/wss/");
      // console.log(11111, '---this.socket');

      this.setupWebSocketEvents();
    },

    setupWebSocketEvents () {
      let token = this.imToken;
      // 打开页面事件
      this.socket.onopen = () => {
        this.isWebSocketConnected = true;
        let appId = this.appId;
        this.socket.send(
          JSON.stringify({ cmd: 1, seq: 2, token: token, appId })
        );
        this.show = true;
        // start heartbeat to keep connection alive
        this.clearAllTimers();
        this.makeInterval = setInterval(() => {
          try {
            if (this.socket && this.socket.readyState === WebSocket.OPEN) {
              this.socket.send(
                JSON.stringify({ cmd: 8, seq: Date.now(), appId: this.appId, token: this.imToken })
              );
            }
          } catch (e) {
            // swallow and let error handler schedule reconnect
          }
        }, 10000);
      };
      // 浏览器端收消息，获得从服务端发送过来的文本消息
      this.socket.onmessage = (msg) => {
        const list = JSON.parse(msg.data);
        // 收到服务端推送的消息
        if (list.cmd == 4) {
          // 清除加载超时
          if (this.loadTimeoutId) {
            clearTimeout(this.loadTimeoutId);
            this.loadTimeoutId = null;
          }

          this.loading = false
          if (list.chatSessions.length <= 0) {
            this.hasMore = false
          } else {
            // 确保有数据时 hasMore 为 true
            this.hasMore = true
          }
          // 保存现有用户的未读数，避免被新数据覆盖
          const existingUnreadCounts = new Map();
          this.userList.forEach(user => {
            if (user && user.id) {
              existingUnreadCounts.set(user.id, user.unreadCount || 0);
            }
          });

          list.chatSessions.forEach((item) => {
            // 如果现有用户有未读数，保持现有值；否则使用新数据
            if (existingUnreadCounts.has(item.id)) {
              item.unreadCount = existingUnreadCounts.get(item.id);
            } else if (typeof item.unreadCount !== 'number') {
              item.unreadCount = 0;
            }
          });

          this.userList = [...this.userList, ...list.chatSessions];
          const map = new Map();
          this.userList.forEach(item => {
            map.set(item.toUserName, item);
          });
          this.userList = Array.from(map.values());

          // console.log(this.userList, 'this.userList');

          // this.userId = list.users[0].id;
          if (this.getUserState) {
            this.listContent.map((v, k) => {
              this.asd(v);
            });
            this.listContent = [];
            this.getUserState = false;
          }
        }
        // 新消息到达（追加到当前会话底部）
        if (list.cmd == 11) {
          // 新用户第一次发消息：根据当前标签页决定插入位置
          const s = list.msg || {};
          const existsIndex = (this.userList || []).findIndex(u => u && (u.id === s.id || u.to === s.to));
          const isOnUnreadTab = this.activeName === '0';
          const isOnAllTab = this.activeName === '2';

          // 判断是否是当前聊天用户
          // cmd==11 中可能使用 owner 字段而不是 from 字段
          const isCurrentChatUser = (
            (s.to === this.itemTo && (s.from === this.imToken || s.owner === this.imToken)) ||
            ((s.from === this.itemTo || s.owner === this.itemTo) && s.to === this.imToken)
          );


          // cmd==11 时 unreadCount 总是 1，需要累加到现有未读数
          const incomingUnread = 1; // 每次新消息都是 +1

          const newSession = {
            id: s.id,
            to: s.to,
            toUserName: s.toUserName,
            toTag: s.toTag || '',
            unreadCount: incomingUnread,
            lastUpdateTimestamp: s.lastUpdateTimestamp
          };

          if (existsIndex > -1) {
            const prev = this.userList[existsIndex] || {};
            // 如果是当前聊天用户，清零未读数；否则累加
            const merged = {
              ...prev,
              ...newSession,
              unreadCount: isCurrentChatUser ? 0 : (prev.unreadCount || 0) + incomingUnread
            };
            this.userList.splice(existsIndex, 1);
            if (isOnUnreadTab || isOnAllTab) {
              this.userList.unshift(merged);
            } else {
              this.userList.push(merged);
            }
          } else {
            // 新会话：如果是当前聊天用户，未读数为0；否则为1
            const finalSession = {
              ...newSession,
              unreadCount: isCurrentChatUser ? 0 : incomingUnread
            };
            if (isOnUnreadTab || isOnAllTab) {
              this.userList.unshift(finalSession);
            } else {
              this.userList.push(finalSession);
            }
          }

          // 如果是当前聊天用户，cmd==11 只是通知有新消息，不添加具体内容到聊天框
          // 具体的消息内容会通过 cmd==7 来添加
          if (isCurrentChatUser) {
            // 只标记为已读，不添加消息到聊天框
            this.allMessageRead();
          }

          this.$forceUpdate();
          return;
        }
        // 聊天历史记录回包
        if (list.cmd == 12) {
          const payload = list.msg || {};
          const newMessages = Array.isArray(payload.content) ? payload.content : [];
          const total = payload.totalElements || newMessages.length || 0;
          const isFirstLoad = !!this.chatHistoryFirstLoadPending;

          if (isFirstLoad) {
            // 首次加载：替换并滚动到底部
            this.list = newMessages.slice().reverse();
            this.$nextTick(() => this.toBottom());
          } else {
            // 加载更多（向上翻页）：前置并保持滚动位置
            const el = this.$el && this.$el.querySelector ? this.$el.querySelector('.ChatareaText') : null;
            const currentScrollTop = el ? el.scrollTop : 0;
            const currentScrollHeight = el ? el.scrollHeight : 0;

            this.list = [...newMessages.slice().reverse(), ...this.list];

            this.$nextTick(() => {
              const el2 = this.$el && this.$el.querySelector ? this.$el.querySelector('.ChatareaText') : null;
              if (el2) {
                const newScrollHeight = el2.scrollHeight;
                el2.scrollTop = newScrollHeight - currentScrollHeight + currentScrollTop;
              }
            });
          }

          // 更新分页与加载状态
          this.chatTotal = total;
          // 基于是否为最后一页判断是否还有更多
          this.chatHasMore = payload && typeof payload.last === 'boolean' ? !payload.last : (newMessages.length >= this.chatPageSize);
          if (this.chatHasMore) {
            this.chatPageNum++;
          }
          this.chatLoading = false;
          this.chatHistoryFirstLoadPending = false;
          return;
        }
        if (list.cmd == 7) {
          // 新消息：将其追加到当前会话的底部
          // 先判断是否是当前聊天用户，如果是则不调用 asd 避免通知
          const isCurrentChatUser = (
            (list.from === this.itemTo && list.to === this.imToken) ||
            (list.from === this.imToken && list.to === this.itemTo)
          );


          if (!isCurrentChatUser) {
            this.asd(list);
          } else {
            // 是当前聊天用户，直接添加到聊天框，不显示通知
            this.list.push(list);
            this.toBottom();
            // 标记为已读
            this.allMessageRead();
          }
          return;
        }
        if (list.chatType == 1 && !this.getUserState) {
          // 先判断是否是当前聊天用户，如果是则不调用 asd 避免通知
          const isCurrentChatUser = (
            (list.from === this.itemTo && list.to === this.imToken) ||
            (list.from === this.imToken && list.to === this.itemTo)
          );

          if (!isCurrentChatUser) {
            this.asd(list);
          } else {
            // 是当前聊天用户，直接添加到聊天框，不显示通知
            this.list.push(list);
            this.toBottom();
            // 标记为已读
            this.allMessageRead();
          }
        }
      };
      // 关闭事件
      this.socket.onclose = () => {
        // this.$message.error('WebSocket关闭')
        this.isWebSocketConnected = false;
        this.clearAllTimers();
        this.scheduleReconnect();
      };
      // 发生了错误事件
      this.socket.onerror = (err) => {
        // this.$message.error('WebSocket 发生错误')
        console.error("WebSocket 发生错误：", err);
        this.isWebSocketConnected = false;
        this.clearAllTimers();
        this.scheduleReconnect();
      };
    },
    scheduleReconnect () {
      if (!this.shouldReconnect) return;
      if (this.reconnectPending) return;
      this.reconnectPending = true;
      this.clearReconnect();
      this.reconnectTimer = setTimeout(() => {
        this.reconnectPending = false;
        this.initWebSocket();
      }, this.reconnectDelay);
    },
    clearReconnect () {
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    },
    // 有新消息提示部分  EEEEEE
    // 处理页面可见性变化
    handleVisibilityChange () {
      if (document.visibilityState === 'visible') {
        this.clearTitleBlink();
        document.title = this.originalTitle;
        // 用户回到页面时重置未读计数
        this.resetUnreadCount();
      }
    },
    // 消息提醒相关方法
    requestNotificationPermission () {
      if ('Notification' in window) {
        // 检查当前权限状态
        if (Notification.permission === 'granted') {
          this.notificationPermission = true;
        } else if (Notification.permission === 'denied') {
          this.notificationPermission = false;
        } else {
          // 请求权限
          Notification.requestPermission().then(permission => {
            this.notificationPermission = permission === 'granted';
            if (permission === 'granted') {
              this.$message.success('桌面通知已启用');
            } else {
              this.$message.warning('桌面通知被禁用，您将错过重要消息提醒');
            }
          }).catch(error => {
            console.error('请求通知权限失败:', error);
            this.notificationPermission = false;
          });
        }
      } else {
        console.warn('此浏览器不支持桌面通知');
        this.$message.warning('您的浏览器不支持桌面通知功能');
      }
    },
    // 通知  显示新消息提醒
    showNewMessageAlert (message = '新消息') {
      // 增加未读计数
      this.unreadCount++;

      // 1. 页面标题闪烁
      this.startTitleBlink();

      // 2. 浏览器通知（如果页面不在前台）- 使用防抖
      if (document.visibilityState === 'hidden' && this.notificationPermission) {
        // 如果已经有定时器在运行，先清除
        if (this.notificationDebounceTimer) {
          clearTimeout(this.notificationDebounceTimer);
          this.notificationDebounceTimer = null;
        }

        // 设置防抖定时器，200ms内只显示最后一次通知（减少延迟）
        this.notificationDebounceTimer = setTimeout(() => {
          this.showBrowserNotification(message);
          this.notificationDebounceTimer = null;
        }, 200);

        // 添加一个保险机制：如果1秒内没有新消息，强制显示通知
        setTimeout(() => {
          if (this.notificationDebounceTimer) {
            clearTimeout(this.notificationDebounceTimer);
            this.notificationDebounceTimer = null;
            this.showBrowserNotification(message);
          }
        }, 1000);

        // 备用方案：使用通知队列（确保所有通知都能显示）
        this.addToNotificationQueue(message);
      }
      // 3. 语音提示
      this.playNotificationSound();
    },
    // 页面标题闪烁
    startTitleBlink () {
      this.clearTitleBlink();
      let blinkCount = 0;
      this.titleBlinkTimer = setInterval(() => {
        if (blinkCount % 2 === 0) {
          document.title = '● 新消息 - ' + this.originalTitle;
        } else {
          document.title = this.originalTitle;
        }
        blinkCount++;
        if (blinkCount >= 10) { // 闪烁5次后停止
          this.clearTitleBlink();
        }
      }, 1000);
    },
    clearTitleBlink () {
      if (this.titleBlinkTimer) {
        clearInterval(this.titleBlinkTimer);
        this.titleBlinkTimer = null;
      }
    },
    // 浏览器桌面通知
    showBrowserNotification (message) {
      if (!('Notification' in window)) {
        console.error('此浏览器不支持桌面通知');
        return;
      }

      if (this.notificationPermission) {
        try {
          // 关闭之前的通知（如果有的话）
          if (this.currentNotification) {
            this.currentNotification.close();
            this.currentNotification = null;
          }

          // 创建新的通知，使用唯一标签让每个通知都能显示
          const notification = new Notification(`新消息提醒 ${this.unreadCount > 1 ? `(${this.unreadCount}条)` : ''}`, {
            body: message,
            icon: '/favicon.ico',
            tag: `chat-notification-${Date.now()}`, // 使用时间戳作为唯一标签
            requireInteraction: false, // 改为false，避免通知堆积
            silent: false // 确保有声音提示
          });

          this.currentNotification = notification;

          notification.onclick = () => {
            window.focus();
            notification.close();
            this.currentNotification = null;
          };

          notification.onclose = () => {
            this.currentNotification = null;
          };

          notification.onerror = (error) => {
            console.error('桌面通知显示错误:', error);
            this.currentNotification = null;
          };

          // 3秒后自动关闭（减少显示时间，避免堆积）
          setTimeout(() => {
            if (notification && !notification.closed) {
              notification.close();
            }
          }, 3000);
        } catch (error) {
          console.error('创建桌面通知时出错:', error);
          this.$message.error('桌面通知显示失败: ' + error.message);
        }
      } else {
        // 如果权限被拒绝，尝试重新请求权限
        if (Notification.permission !== 'denied') {
          this.requestNotificationPermission();
        }
      }
    },
    // 消息语音提示
    playNotificationSound () {
      try {
        // 创建音频上下文
        if (!this.audioContext) {
          this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        }

        // 创建简单的提示音
        const oscillator = this.audioContext.createOscillator();
        const gainNode = this.audioContext.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(this.audioContext.destination);

        oscillator.frequency.setValueAtTime(800, this.audioContext.currentTime);
        oscillator.frequency.setValueAtTime(600, this.audioContext.currentTime + 0.1);

        gainNode.gain.setValueAtTime(0.3, this.audioContext.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + 0.3);

        oscillator.start(this.audioContext.currentTime);
        oscillator.stop(this.audioContext.currentTime + 0.3);
      } catch (error) {
        console.warn('无法播放提示音:', error);
      }
    },
    // 简化的通知显示方法（无防抖）
    showNotificationSimple (message) {
      if (document.visibilityState === 'hidden' && this.notificationPermission) {
        const now = Date.now();
        // 如果距离上次通知超过500ms，才显示新通知（减少间隔）
        if (now - this.lastNotificationTime > 500) {
          this.showBrowserNotification(message);
          this.lastNotificationTime = now;
        }
      }
    },

    // 添加通知到队列
    addToNotificationQueue (message) {
      this.notificationQueue.push({
        message: message,
        timestamp: Date.now()
      });
      this.processNotificationQueue();
    },

    // 处理通知队列
    processNotificationQueue () {
      if (this.isProcessingNotification || this.notificationQueue.length === 0) {
        return;
      }

      this.isProcessingNotification = true;
      const notification = this.notificationQueue.shift();

      this.showBrowserNotification(notification.message);

      // 500ms后处理下一个通知
      setTimeout(() => {
        this.isProcessingNotification = false;
        this.processNotificationQueue();
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  padding: 30px;
  // background-color: pink;
  display: flex;
  // background-color: #f5f5f5;
}

.leftTag {
  width: 150px;
  background-color: #fff;
  background-color: #f7f7f7;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  box-sizing: border-box;

  .leftTagList {
    margin-top: 10px;

    .leftTagItem {
      padding: 10px;
      box-sizing: border-box;
      cursor: pointer;
      /* 鼠标经过变成手 */
    }

    .leftTagItemActive {
      background-color: #409eff;
      color: #fff;
    }
  }
}

.content {
  width: 90%;
  height: 800px;
  // height: 400px;
  // background-color: pink;
  background-color: #f7f7f7;
  // border: 1px solid #ccc;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  padding-bottom: 10px;
}

.Recentchats {
  width: 20%;
  height: 100%;
  background-color: #f7f7f7;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;

  .FunctionalArea {
    margin: 10px;
    flex-shrink: 0; /* 固定高度，不收缩 */
    background-color: #f7f7f7;
    z-index: 10;
  }

  .UserListArea {
    flex: 1; /* 占据剩余空间 */
    height: 400px; /* 设置最小高度确保有滚动条 */
    max-height: 750px; /* 设置最大高度限制 */
    overflow-y: auto; /* 垂直滚动 */
    padding: 0 10px 10px 10px;

    .infinite-list {
      list-style: none;
      padding: 0;
      margin: 0;

      .infinite-list-item {
        padding: 15px;
        border-bottom: 1px solid #eee;
        background-color: #fff;
        margin-bottom: 5px;
        border-radius: 4px;
        min-height: 50px; /* 设置最小高度 */
        display: flex;
        align-items: center;
      }
    }
  }
  .loading-item {
    padding: 15px;
    text-align: center;
    color: #999;
    background-color: #f5f5f5;
    border-radius: 4px;
    margin-bottom: 5px;

    i {
      margin-right: 5px;
      animation: rotating 2s linear infinite;
    }
  }
  .no-more-item {
    padding: 15px;
    text-align: center;
    color: #999;
    background-color: #f9f9f9;
    border-radius: 4px;
    margin-bottom: 5px;
    font-size: 12px;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    background-color: skyblue;
  }

  .RecentchatsItem {
    display: flex;
    align-items: center;
    padding: 20px 10px;
    height: 80px;
    background-color: #ebeef4;
    cursor: pointer;

    img {
      width: 40px;
      height: 40px;
    }

    .more {
      display: flex;
      align-items: center;
    }

    .itemRight {
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      margin: 0 0 0 20px;
      display: flex;
      justify-content: space-between;
    }
    .userInfo {
      display: flex;
      flex-direction: column;
      .userTag {
        display: flex;
        flex-wrap: wrap;
        max-width: 200px; // 限制标签容器最大宽度
        .userTagItem {
          padding: 5px;
          background-color: skyblue;
          border-radius: 5px;
          color: #fff;
          margin-left: 3px;
          margin-bottom: 2px;
          max-width: 80px; // 限制单个标签最大宽度
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
        }
      }
    }
  }

  .RecentchatsItemActive {
    background-color: #c4c4c5;
  }
}

.Chatarea {
  width: 70%;
  display: flex;
  flex-direction: column;

  .ChatareaName {
    height: 50px;
    box-sizing: border-box;
    padding: 20px;
    border-bottom: 1px solid #ccc;
  }

  .ChatareaText {
    width: 100%;
    height: 550px;
    background-color: #fff;
    padding: 10px;
    overflow-y: auto;
    border: 2px dashed transparent;

    &.drag-over {
      border-color: #409eff;
      background-color: #f0f9ff;
    }

    .left_view {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 30px;
      }

      .leftText {
        max-width: 40%;
        padding: 10px;
        background-color: pink;
        border-radius: 10px;
        overflow-wrap: break-word;
        img {
          width: 100px;
          height: auto;
        }
      }
    }

    .right_view {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 10px;

      img {
        width: 40px;
        height: 40px;
        margin-left: 30px;
      }

      .rightText {
        max-width: 40%;
        padding: 10px;
        background-color: #95ec69;
        border-radius: 10px;
        overflow-wrap: break-word;
      }
    }
  }

  .ChatareaSend {
    width: 100%;
    height: 200px;
    border-top: 1px solid #ccc;
    padding: 20px 0 20px 20px;
    box-sizing: border-box;
    position: relative;

    .sendText {
      width: 100%;
      height: 130px;
      overflow: auto;
    }

    ::v-deep .el-textarea {
      width: 100%;
      height: 130px;
      overflow: auto;
    }

    ::v-deep .el-textarea__inner {
      width: 100%;
      height: 130px;
      overflow: auto;
    }

    .sendBtn {
      // background-color: #f2f2f2;
      // border-radius: 10px;
      // padding: 10px 20px;
      position: absolute;
      bottom: 0px;
      right: 10px;
      cursor: pointer;
    }

    .sendActions {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      gap: 10px;
      margin-top: 10px;
      // position: absolute;
      // bottom: 0px;
      // left: 10px;
    }

    .image-message {
      img {
        max-width: 200px;
        max-height: 200px;
        border-radius: 8px;
        cursor: pointer;
        transition: transform 0.2s;

        &:hover {
          transform: scale(1.05);
        }
      }
    }
  }
}

// 优化 el-badge 样式
::v-deep .el-badge__content {
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  border-radius: 50%;
  background-color: #f56c6c;
  color: white;
  font-weight: bold;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

// 用户列表项中的 badge 样式
.user-badge {
  position: relative;
  display: inline-block;

  .name {
    font-weight: 500;
    color: #333;
    margin-bottom: 2px;
  }

  .user-id {
    font-size: 12px;
    color: #999;
  }
}

// 当有未读消息时高亮显示
.RecentchatsItem {
  position: relative;

  &.has-unread {
    background-color: #f0f9ff;
    border-left: 3px solid #409eff;
  }
}

/* 用户列表区域滚动条样式 */
.UserListArea::-webkit-scrollbar {
  width: 6px;
}

.UserListArea::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.UserListArea::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.UserListArea::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 聊天区域滚动条样式 */
.ChatareaText::-webkit-scrollbar {
  width: 6px;
}

.ChatareaText::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.ChatareaText::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.ChatareaText::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 文本消息保留换行和空格 */
.text-message {
  white-space: pre-wrap;
  word-break: break-word;
}

/* Firefox 滚动条样式 */
.UserListArea {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.ChatareaText {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 加载动画 */
@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 聊天区域loading样式 */
.chat-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  color: #409eff;
  font-size: 14px;

  i {
    margin-right: 8px;
    font-size: 16px;
    animation: rotating 1s linear infinite;
  }
}

/* 标签样式 */
.tagList {
  margin: 20px 0;

  .tag-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .tag-title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }

    .tag-arrow {
      margin-left: 8px;
      color: #999;
      font-size: 14px;
    }
  }

  .tag-buttons {
    .tag-add-btn {
      margin-bottom: 15px;
      color: #409eff;
      border: 1px dashed #409eff;
      background: transparent;
      padding: 8px 16px;
      border-radius: 4px;

      &:hover {
        background: #f0f9ff;
        border-color: #66b1ff;
      }
    }

    .tag-row {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .tag-btn {
        position: relative;
        padding: 8px 16px;
        border: 1px solid #dcdfe6;
        background: #fff;
        color: #606266;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          border-color: #409eff;
          color: #409eff;
        }

        &.tag-selected {
          border-color: #409eff;
          background: #f0f9ff;
          color: #409eff;

          .tag-check {
            position: absolute;
            top: -2px;
            right: -2px;
            background: #409eff;
            color: #fff;
            border-radius: 50%;
            width: 16px;
            height: 16px;
            font-size: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}
</style>
